document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-variant-select]');
  if (!select) return;

  var form = select.closest('form');
  var idInput = form && form.querySelector('[name="id"]');
  if (idInput) idInput.value = select.value;
});

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (!toggle) return;

  var menu = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!menu) return;

  var isOpen = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!isOpen));
  menu.hidden = isOpen;
});

document.addEventListener('submit', function (event) {
  var form = event.target.closest('[data-product-form]');
  if (!form) return;

  event.preventDefault();

  var submit = form.querySelector('[type="submit"]');
  var status = form.querySelector('[data-product-form-status]');
  var originalLabel = submit ? submit.textContent : '';

  if (submit) {
    submit.disabled = true;
    submit.textContent = 'Adding to bag…';
  }

  if (status) {
    status.hidden = true;
    status.textContent = '';
    status.removeAttribute('data-state');
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: new FormData(form)
  })
    .then(function (response) {
      return response.json().catch(function () { return null; }).then(function (payload) {
        if (!response.ok) {
          var message = payload && (payload.description || payload.message);
          throw new Error(message || 'We could not add this membership to the bag. Please try again.');
        }
        return payload;
      });
    })
    .then(function () {
      window.location.assign('/cart');
    })
    .catch(function (error) {
      if (status) {
        status.textContent = error.message || 'We could not add this membership to the bag. Please try again.';
        status.dataset.state = 'error';
        status.hidden = false;
      }

      if (submit) {
        submit.disabled = false;
        submit.textContent = originalLabel;
      }
    });
});
